import { render, staticRenderFns } from "./TagsFilter.vue?vue&type=template&id=3fa740bb&scoped=true&"
import script from "./TagsFilter.vue?vue&type=script&lang=js&"
export * from "./TagsFilter.vue?vue&type=script&lang=js&"
import style0 from "./TagsFilter.vue?vue&type=style&index=0&id=3fa740bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa740bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/html/insights/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VChip,VIcon,VRadio,VRadioGroup,VTooltip})
